import type { RefObject } from 'react';
import { memo } from 'react';

import type { TabSymbol } from '@/features/dashboard/state/EditChartApp';

import { SortableItem } from './SortableItem';

type DroppableAreaProps = {
  id: string;
  items: TabSymbol[];
  muted?: boolean;
  baseIndex?: number;
  container: RefObject<HTMLDivElement | null>;
};

const DroppableAreaComponent = ({
  id,
  items,
  muted = false,
  baseIndex = 0,
  container
}: DroppableAreaProps) => {
  return (
    <div
      className='flex min-h-[100px] flex-1 flex-col'
      data-muted={muted}
    >
      {items.map((item, index) => (
        <SortableItem
          key={item.id}
          container={container}
          item={item}
          itemIndex={index + baseIndex}
          sourceListId={id}
        />
      ))}
    </div>
  );
};

export const DroppableArea = memo(DroppableAreaComponent);
